import { ToggleConfig } from 'apprise-frontend-core/toggle/context'
import { FormExcludes } from 'apprise-frontend-core/utils/formexcludes'
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { useTenantPermissionModule } from 'apprise-frontend-iam/tenant/plugins'
import { AuthzConfig, AuthzConfigProvider, UserClientCacheProvider, UserCloneProvider, UserExcludes, UserExcludesProvider, UserToggleProvider, UserToggles } from 'apprise-frontend-iam/user/context'
import { useTagPermissionModule } from 'apprise-frontend-iam/user/modules.impl'
import { PropsWithChildren } from 'react'
import { UserInitialiser } from './initialiser'
import { UserLoader } from './loader'
import { UserPermissionModule, UserPreferencesModule, useUserPermissionModules } from './modules'
import { createProvider } from 'apprise-frontend-core/state/factory'

export type UserProps = PropsWithChildren<Partial<ToggleConfig<UserToggles> & AuthzConfig & {

    formExcludes: FormExcludes<UserExcludes>
}>>


// since (01/26): keep registries inlined so that it resets when this is remounted on HMR.
// if it didn't, then app initialisers would register multiple times with various forms of errors.

export const [UserPermissionModuleProvider, useRegisteredUserPermissionModules] = createProvider({

    modules: [] as UserPermissionModule<any>[]
})


export const [UserPreferenceModuleProvider, useRegisteredUserPreferenceModules] = createProvider({

    modules: [] as UserPreferencesModule[]
})

// initialises the model and loads users, and mounts the state if required.
export const Users = (props: UserProps) => {

    const { children, toggles, formExcludes, ...config } = props

    return <AuthzConfigProvider {...config}>
        <UserClientCacheProvider>
            <UserPermissionModuleProvider>
                <UserPreferenceModuleProvider>
                    <UserCloneProvider>
                        <UserToggleProvider toggles={toggles}>
                            <UserExcludesProvider {...formExcludes}>
                                <UserInitialiser>
                                    <UserLoader>
                                        <InitialiseDependencies>
                                            {children}
                                        </InitialiseDependencies>
                                    </UserLoader>
                                </UserInitialiser>
                            </UserExcludesProvider>
                        </UserToggleProvider>
                    </UserCloneProvider>
                </UserPreferenceModuleProvider>
            </UserPermissionModuleProvider>
        </UserClientCacheProvider>
    </AuthzConfigProvider>

}


// installs modules for dependencies that would otherwise introduce dep cycles ( currently only apprise-frontend-tags).
const InitialiseDependencies = (props: PropsWithChildren) => {

    const { children } = props

    const permissionRegistry = useUserPermissionModules()

    const tagPermissions = useTagPermissionModule()
    const tenantPermissions = useTenantPermissionModule()

    const { content } = useRenderGuard({

        render: children,

        orRun: () => {

            permissionRegistry.register(tagPermissions)
            permissionRegistry.register(tenantPermissions)
        }


    })
    return content
}
